import { PermissionBasedSidebarMenu } from './';

interface Props {
  height?: number;
}

const SidebarContent = ({ height = 0 }: Props) => {
  return (
    <div className="sidebar-content flex flex-1 py-5 pe-2 min-h-0">
      <div
        className="scrollable-y-hover grow flex min-h-0 ps-2 lg:ps-5 pe-1 lg:pe-3 overflow-y-auto overflow-x-hidden"
        style={{
          ...(height > 0 && {
            height: `${height}px`,
            maxHeight: `${height}px`,
          }),
        }}
      >
        <PermissionBasedSidebarMenu />
      </div>
    </div>
  );
};

export { SidebarContent };
